import Vue from 'vue';
import Autocomplete from 'vue2-autocomplete-js';
import _ from 'lodash';

Vue.component('search-component', {
    props: {
        searchQuery: {
            type: String,
        },
        searchEntries: {
            type: Array,
        },
    },

    components: {
        Autocomplete,
    },

    data() {
        return {
            groupedResults: null,
            showedResults: null,
            activeType: 'all',
        };
    },

    mounted() {
        this.groupedResults = _.groupBy(this.searchEntries, 'type');
        this.showedResults = this.searchEntries;
    },

    methods: {
        filterResults(key) {
            this.activeType = key;
            if (key === 'all') {
                this.showedResults = this.searchEntries;
            } else {
                this.showedResults = this.searchEntries.filter((element, index) => element.type === key);
            }
        },
    },

});
